import * as React from "react";
import { forwardRef } from "react";
const SvgTrace = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	height: 3,
	rx: .42,
	width: 11.7,
	x: 10.6,
	y: 15
}), /* @__PURE__ */ React.createElement("rect", {
	fill: "currentColor",
	height: 3,
	rx: .42,
	width: 7.2,
	x: 17.8,
	y: 20
}), /* @__PURE__ */ React.createElement("rect", {
	fill: "currentColor",
	height: 3,
	rx: .42,
	width: 18,
	x: 7,
	y: 10
}), /* @__PURE__ */ React.createElement("path", {
	d: "M31 0h1v2h-1zM0 0h1v2H0zm31 3h1v2h-1zM0 3h1v2H0zm31 3h1v2h-1zM0 6h1v2H0zm31 3h1v2h-1zM0 9h1v2H0zm31 3h1v2h-1zM0 12h1v2H0zm31 3h1v2h-1zM0 15h1v2H0zm31 3h1v2h-1zM0 18h1v2H0zm31 3h1v2h-1zM0 21h1v2H0zm31 3h1v2h-1zM0 24h1v2H0zm31 3h1v2h-1zM0 27h1v2H0zm31 3h1v2h-1zM0 30h1v2H0z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgTrace);
export default ForwardRef;
